import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';
import useVirtualPageView from '../../../../../pro/services/analytics/useVirtualPageView';
import FormGroup from '../../../../../../components/global/FormGroup';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    phone_number: PropTypes.string.isRequired,
  }).isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
};

const RegistrationPhoneVerify = ({
  className,
  loading,
  handleChange,
  onPinCodeResend,
  values,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  useVirtualPageView({
    title:
      'Reserve Waldo for your wedding today! - Phone Authentication Verify',
    path: '/phone-auth-verify',
  });

  return (
    <div className={classes}>
      <div className="row">
        <div className="col-12">
          <FormGroup
            id="code"
            name="code"
            label=""
            className="mb-1"
            required
            onChange={handleChange}
            value={values.code}
          />
          <Button btnStyle="link" onClick={onPinCodeResend} disabled={loading}>
            {loading ? 'Resending...' : 'Resend code'}
          </Button>
        </div>
      </div>
    </div>
  );
};

RegistrationPhoneVerify.propTypes = propTypes;

export default RegistrationPhoneVerify;
